import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ResponsiveContainer = ({ children }) => {
  return <div className={styles.responsiveContainer}>{children}</div>;
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

export default ResponsiveContainer;
